export default __webpack_public_path__ + "static/media/excabiular-series.60e470f2.webp";